import { render, staticRenderFns } from "./Superadmin.vue?vue&type=template&id=2c7c072a&"
import script from "./Superadmin.vue?vue&type=script&lang=js&"
export * from "./Superadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports